module.exports = __webpack_public_path__ + "static/media/Img_8.bfd7d45b.jpg";